import Swal from "sweetalert2";

export const Alert = async ({
  title,
  message,
  icon = 'success',
  showConfirmButton = false,
  confirmButtonText = 'Confirmar',
  showCancelButton = false,
  cancelButtonText = 'Cancelar',
  input = null,
  inputPlaceholder = '',
  timer = null, 
  allowOutsideClick = true,
  allowEscapeKey = true,
  showCloseButton = true, 
  html = null, 
  didOpen = null,
  preConfirm = null
}) => {
  const result = await Swal.fire({
    title,
    text: message,
    icon,
    showConfirmButton,
    confirmButtonText,
    showCancelButton,
    cancelButtonText,
    reverseButtons: true,
    timer,
    timerProgressBar: timer ? true : false,
    customClass: {
      actions: 'swal2-actions-horizontal'
    },
    input,
    inputPlaceholder,
    allowOutsideClick,
    allowEscapeKey,
    showCloseButton, 
    html, 
    didOpen,
    preConfirm
  });

  if (!result.isConfirmed) return null;

  return input ? result.value : true;
};

export default Alert;
